import React, {useContext, useState} from "react";
import {IdentityContext} from "../../../../../context/identity-context";
import SecurityService from "../../../../../services/security-service";
import styles from "./modal-content-authorize-security.module.scss";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import confirmIcon from "../../../../../assets/confirm-orange.svg";
import SuccessModalContent
  from "../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  SECURITY_AUTHORIZE_ERROR,
  SECURITY_AUTHORIZE_SUCCESS
} from "../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../securities/security-details/components/modal-content-error/modal-content-error";

const AuthorizeSecurityModalContent = ({data, updateTable, onClose, modalConfig}) => {
  const SUCCESS_TITLE = "SALES REPORT AUTHORIZED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const { setStyle } = modalConfig;
  const [ loading, setLoading] = useState(false);
  const [ page, setPage ] = useState(0);
  const { user } = useContext(IdentityContext);
  const securityService = new SecurityService();
  const { securityId, username } = data;

  const authorizeOrders = async () => {
    setLoading(true);
    try {
      await securityService.authorizeOrders(securityId, user.attributes['custom:entity_id'], username);
      updateTable(securityId, username);
      setStyle(styles['success-modal'])
      setPage(1);
    } catch(error) {
      setStyle(styles['error-modal'])
      setPage(2)
    } finally {
      setLoading(false);
    }
  }

  const close = () => {
    setStyle(styles['confirm-modal']);
    onClose();
  }

  return page === 0 ? (
    <div className={styles['authorize-security']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>YOU ARE ABOUT TO PROCEED WITH LEVEL 2 (CHECKER) SUBMISSION OF THE SALES REPORT TO PDTC REGISTRY.</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Confirm" src={confirmIcon} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>Click Authorize to submit.</p>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button variant="warning" onClick={() => authorizeOrders()}>
              {loading ? <Spinner size="sm" animation="border" /> : 'AUTHORIZE'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : ( page === 1
    ? <SuccessModalContent title={SUCCESS_TITLE} message={SECURITY_AUTHORIZE_SUCCESS} onClose={close}/>
    : <ErrorModalContent title={ERROR_TITLE} message={SECURITY_AUTHORIZE_ERROR} onClose={close}/>)
}

export default AuthorizeSecurityModalContent;
